var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 13.333L15.0003 13.333C15.4424 13.333 15.8663 13.1574 16.1788 12.8449C16.4914 12.5323 16.667 12.1084 16.667 11.6663L16.667 4.99967C16.667 4.55765 16.4914 4.13372 16.1788 3.82116C15.8663 3.5086 15.4424 3.33301 15.0003 3.33301L8.33366 3.33301C7.89163 3.33301 7.46771 3.5086 7.15515 3.82116C6.84259 4.13372 6.66699 4.55765 6.66699 4.99967L6.66699 6.66634M11.667 6.66634C12.109 6.66634 12.5329 6.84194 12.8455 7.1545C13.1581 7.46706 13.3337 7.89098 13.3337 8.33301L13.3337 14.9997C13.3337 15.4417 13.1581 15.8656 12.8455 16.1782C12.5329 16.4907 12.109 16.6663 11.667 16.6663L5.00033 16.6663C4.5583 16.6663 4.13437 16.4907 3.82181 16.1782C3.50925 15.8656 3.33366 15.4417 3.33366 14.9997L3.33366 8.33301C3.33366 7.89098 3.50925 7.46706 3.82181 7.1545C4.13438 6.84194 4.5583 6.66634 5.00033 6.66634L11.667 6.66634Z",
    stroke: "#00FFE0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.8b144f8e40f306efa3b34017a4fee7ae.svg";
export { ForwardRef as ReactComponent };